import { gql, TypedDocumentNode } from '@apollo/client';
import { PAYMENT_METHOD_FRAGMENT, PaymentMethod } from '../usePaymentMethodsQuery';
import { Psd2Params } from '../usePsd2';

export type UpdatePaymentMethodMutationInput = {
  data: {
    type: 'payments';
    attributes: Psd2Params & {
      encrypted_data: string;
      billing_address: {
        country_name: string;
        extended_address: string | null;
        id: string | null;
        locality: string;
        postal_code: string;
        region: string;
        street_address: string;
      };
    };
  };
};

export type UpdatePaymentMethodMutationVariables = {
  id: string;
  input: UpdatePaymentMethodMutationInput;
};

export type UpdatePaymentMethodMutation = {
  updatePaymentMethod: {
    __typename: 'RestUpdatePaymentMethod';
    data: PaymentMethod;
  };
};

export const UPDATE_PAYMENT_METHOD_MUTATION: TypedDocumentNode<
  UpdatePaymentMethodMutation,
  UpdatePaymentMethodMutationVariables
> = gql`
  mutation UpdatePaymentMethodMutation($id: String!, $input: UpdatePaymentMethodMutationInput!) {
    updatePaymentMethod(id: $id, input: $input)
      @rest(
        type: "RestUpdatePaymentMethod"
        endpoint: "cart"
        path: "/v3.5/payments/{args.id}"
        method: "PATCH"
      ) {
      data @type(name: "RestPaymentMethod") {
        ...PaymentMethodFragment
      }
    }
  }
  ${PAYMENT_METHOD_FRAGMENT}
`;
